import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { map, take } from 'rxjs/operators';
import { UserRoles } from '../../../../../api-authorization/api-authorization.constants';
import { AuthorizeService, IUser } from '../../../../../api-authorization/authorize.service';

@Injectable({ providedIn: 'root' })
export class AppTitleService {

  private defaultPrefix = 'AI Platform |';

  constructor(
    private title: Title,
    private userService: AuthorizeService
  ) { }

  setTitle(pageTitle: string) {
    this.userService.getUser()
      .pipe(take(1))
      .subscribe(user => {
        this.title.setTitle(this.buildTitle(user, pageTitle));
      });
  }

  private buildTitle(user: IUser | null, pageTitle: string): string {
    let prefix = this.defaultPrefix;
    let enabled = `${user.WhiteLabelEnabled}`;

    if (enabled?.toLowerCase() === "true" && ( user?.UserRole === UserRoles.Customer || (user?.UserRole === UserRoles.LiveAgent && user.ParentBrowserTitle !=null))) {
      prefix = `${user.ParentBrowserTitle} | `  || '';
    }
    
    return prefix ? `${prefix} ${pageTitle}` : pageTitle;
  }
}
